export default __webpack_public_path__ + "static/media/metamask-logo.5d3b6116.svg";